import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Card, CardHeader, CardBody, Row, Col, Container } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { DateTime } from 'luxon';

import RouteService from '../../../services/RouteService';
import HelperNavigation from '../../common/HelperNavigation';
import globalTranslations from '../../../i18n/globalTranslations';
import Paths from '../../../types/Paths';
import { modelOf } from '../../../prop-types';
import ContentForState from '../../loader/ContentForState';
import SEOTitle from '../../head/SEOTitle';
import PageTitle from '../../common/PageTitle';
import CustomerUserStore from '../../../store/CustomerUserStore';
import RequestState from '../../../types/RequestState';
import Price from '../../product/Price';

const labels = {
  creditStatusTitle: (
    <FormattedMessage
      id="creditAccount.accountStatusTitle"
      defaultMessage="Credit account status"
    />
  ),
  limit: (
    <FormattedMessage
      id="creditAccount.limitTitle"
      defaultMessage="Credit limit"
    />
  ),
  balance: (
    <FormattedMessage
      id="creditAccount.balanceTitle"
      defaultMessage="Balance"
    />
  ),
  creditUsed: (
    <FormattedMessage
      id="creditAccount.creditUsedTitle"
      defaultMessage="Credit used"
    />
  ),
  dateUpdated: <FormattedMessage {...globalTranslations.dateUpdatedTitle} />,
};

@observer
export class MyAccountCreditAccount extends Component {
  getCreditAccountState = () => {
    const { customerUserStore } = this.props;
    return customerUserStore.creditAccountState;
  };

  getCreditAccount = () => {
    const { customerUserStore } = this.props;
    return customerUserStore.creditAccount;
  };

  getBreadcrumbsPath = () => {
    const { intl, routeService } = this.props;
    return routeService.transformBreadCrumbs([
      {
        text: intl.formatMessage(globalTranslations.myAccount),
        url: Paths.MyAccount,
      },
      {
        text: intl.formatMessage(globalTranslations.creditAccountTitle),
        url: Paths.MyAccountCreditAccount,
      },
    ]);
  };

  render() {
    const creditAccount = this.getCreditAccount();
    if (
      this.getCreditAccountState() === RequestState.LOADED &&
      !creditAccount
    ) {
      return null;
    }

    return (
      <Fragment>
        <HelperNavigation breadcrumbsPath={this.getBreadcrumbsPath()} />
        <SEOTitle title={{ ...globalTranslations.creditAccountTitle }} />
        <ContentForState
          state={this.getCreditAccountState()}
          forLoaded={() => {
            return (
              <div className="MyAccountCreditAccount">
                <PageTitle>
                  <FormattedMessage
                    {...globalTranslations.creditAccountTitle}
                  />
                </PageTitle>
                <Container className="MyAccountCreditAccount__container">
                  <Row>
                    <Col>
                      <Card>
                        <CardHeader>{labels.creditStatusTitle}</CardHeader>
                        <CardBody>
                          <Container className="MyAccountCreditAccount__credit-info-container">
                            <Row>
                              <Col>{labels.limit}</Col>
                              <Col>
                                <Price price={creditAccount.limit} />
                              </Col>
                            </Row>
                            <Row>
                              <Col>{labels.creditUsed}</Col>
                              <Col>
                                <Price price={creditAccount.credit_used} />
                              </Col>
                            </Row>
                            <Row>
                              <Col>{labels.balance}</Col>
                              <Col>
                                <Price price={creditAccount.balance} />
                              </Col>
                            </Row>
                            <Row>
                              <Col className="MyAccountCreditAccount__date-updated">
                                {labels.dateUpdated}
                                {': '}
                                {DateTime.fromISO(
                                  creditAccount.date_updated
                                ).toLocaleString(
                                  DateTime.DATETIME_MED_WITH_SECONDS
                                )}
                              </Col>
                            </Row>
                          </Container>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Container>
              </div>
            );
          }}
        />
      </Fragment>
    );
  }
}

MyAccountCreditAccount.propTypes = {
  customerUserStore: modelOf(CustomerUserStore).isRequired,
  intl: intlShape.isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired,
};

export default injectIntl(
  withRouter(
    inject('routeService', 'customerUserStore')(MyAccountCreditAccount)
  )
);
